import { createApp } from 'vue'
import App from './App.vue'
import './assets/styles/global.css';

createApp(App).mount('#app')
